export const ACTION_CODE = 'PENNYLANE' + '_ACTION';
